import moment from 'moment';
import {ColumnTable} from 'arquero';

export function some_samples(p_dataset, column_idx){

  let aq_table = g_aq.from(p_dataset);
  const column_name = aq_table.columnName(column_idx);

  console.log(column_name);
  let qq = g_aq.agg(aq_table, g_aq.op.sum(column_name));

  aq_table
  // .groupby(0)
  .orderby(g_aq.desc('apv_bet'))
  .derive({apv_bet_rank: g_aq.op.rank()})
  .orderby('game_brand_code')
  .derive({game_brand_code_rank: g_aq.op.rank()})
  .print();

  // g_aq.from(result_list[1]).join(aq_table_4, [['game_brand_code', 'game_kind_code']])
  // .print();

  // aqt_game_all_total = aqt_game_all_total.join(
  //   g_aq.from(SessionStorage.getItemAsJSON('game_kind_list')),
  //   [['game_kind_code']],
  // )

  // const qq = [
  //   'apv_bet',
  //   'house_net_win',
  // ]
  // .reduce((ac, key) => ({...ac, [key]: key + '|prev'}), {game_brand_code: 'game_brand_code'});
}

g_aq.addFunction('datetime_diff', (dt_x, dt_y, period = 'day') => {
  return moment(dt_x).diff(moment(dt_y), period);
});

Object.assign(ColumnTable.prototype, {

  build_expression(functor, fields){
    let exp = {};
    this.columnNames().forEach(em_i => {
      if(fields.includes(em_i))
        exp[em_i] = g_aq.escape(d => functor(d, em_i));
    });
    return exp;
  },

  build_operation(functor, fields){
    let exp = {};
    this.columnNames().forEach(em_i => {
      if(fields.includes(em_i))
        exp[em_i] = functor(em_i);
    });
    return exp;
  },

  assert_columns(p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      exp[em_i] = g_aq.escape(d => d[em_i]);
    });
    return this.derive(exp);
  },

  rename_columns(p_suffix, p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      exp[em_i] = `${em_i}${p_suffix}`;
    });
    return this.rename(exp);
  },

  convert2_float(p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      exp[em_i] = g_aq.escape(d => g_aq.op.parse_float(d[em_i]));
    });
    return this.derive(exp);
  },

  derive_avg_per_day(p_rpt_days, p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      const new_name = em_i.replace('|total', '|pday');
      exp[new_name] = g_aq.escape(d => d[em_i] / p_rpt_days);
    });
    return this.derive(exp);
  },

  derive_ratio_of_total(p_grand_summary, p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      const new_name = em_i.replace('|total', '|ratio');
      exp[new_name] = g_aq.escape( (d, $) => d[em_i] / $.p_grand_summary[em_i]);
    });
    return this.params({p_grand_summary}).derive(exp);
  },

  derive_growth_amount(p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      exp[`${em_i}|gr_amt`] = g_aq.escape(d => (d[`${em_i}|curr`] - d[`${em_i}|prev`]) || 0);
    });
    return this.derive(exp);
  },

  derive_growth_rate(p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      exp[`${em_i}|gr_rate`] = g_aq.escape(d => ((d[`${em_i}|curr`] / d[`${em_i}|prev`]) - 1) || 0);
    });
    return this.derive(exp);
  },

  derive_days_ago(p_columns){
    let exp = {};
    p_columns.forEach(em_i => {
      exp[`${em_i}_ago`] = g_aq.escape(d => g_aq.op.datetime_diff(moment(), d[em_i]));
    });
    return this.derive(exp);
  },

  convert_basic_metrics(){
    const numeric_metrics = [
      'apv_bet',
      'house_net_win',
      'binded_bet',
      'binded_house_net_win',
      'dpst_amt',
      'wdrl_amt',
      'bonus_out_amt',
      'bonus_19_amt',
      'bonus_20_amt',
      'rpoint_add_amt',
      'game_item_count',
      'game_item_cost',
      'game_item_bet',
      'game_item_win',
      'join_amt',
    ];
    return this.derive(this.build_expression((d, field) => g_aq.op.parse_float(d[field]), numeric_metrics));
  },

  derive_basic_metrics() {
    // 工具函式：根據欄位條件自動組合 derive 物件
    function buildDeriveObj(table, defs) {
      const cols = table.columnNames();
      return defs.reduce((obj, def) => {
        if (def.fields.every(f => cols.includes(f))) obj[def.key] = def.fn;
        return obj;
      }, {});
    }

    // 第一層
    const defs1 = [
      {key: 'play_net_win', fields: ['house_net_win'], fn: d => d.house_net_win * -1},
      {key: 'nature_bet', fields: ['apv_bet', 'binded_bet'], fn: d => d.apv_bet - d.binded_bet},
      {key: 'nature_house_net_win', fields: ['house_net_win', 'binded_house_net_win'], fn: d => d.house_net_win - d.binded_house_net_win},
      {key: 'nature_dpst_amt', fields: ['dpst_amt', 'join_amt'], fn: d => d.dpst_amt - d.join_amt},
      {key: 'revenue', fields: ['dpst_amt', 'wdrl_amt'], fn: d => d.dpst_amt - d.wdrl_amt},
      {key: 'bonus_amt', fields: ['bonus_out_amt', 'bonus_19_amt'], fn: d => d.bonus_out_amt - d.bonus_19_amt},
      {key: 'gm_cvt_rate', fields: ['gm_cvt_users', 'reg_dau'], fn: d => (d.gm_cvt_users != null && d.reg_dau != null && d.reg_dau !== 0) ? d.gm_cvt_users / d.reg_dau : 0},
      {key: 'dpst_01_cvt_rate', fields: ['dpst_01_cvt_users', 'reg_dau'], fn: d => (d.dpst_01_cvt_users != null && d.reg_dau != null && d.reg_dau !== 0) ? d.dpst_01_cvt_users / d.reg_dau : 0},
    ];
    let t = this.derive(buildDeriveObj(this, defs1));

    // 第二層
    const defs2 = [
      {key: 'profit', fields: ['house_net_win', 'bonus_amt', 'bonus_20_amt'], fn: d => d.house_net_win - d.bonus_amt + d.bonus_20_amt},
      {key: 'house_edge', fields: ['house_net_win', 'apv_bet'], fn: d => (d.apv_bet !== 0) ? d.house_net_win / d.apv_bet : 0},
      {key: 'nature_dpst_amt_rate', fields: ['nature_dpst_amt', 'dpst_amt'], fn: d => (d.dpst_amt !== 0) ? d.nature_dpst_amt / d.dpst_amt : 0},
      {key: 'bonus_rate', fields: ['bonus_amt', 'apv_bet'], fn: d => (d.apv_bet !== 0) ? d.bonus_amt / d.apv_bet : 0},
      {key: 'revenue_rate', fields: ['revenue', 'dpst_amt'], fn: d => (d.dpst_amt !== 0) ? d.revenue / d.dpst_amt : 0},
    ];
    return t.derive(buildDeriveObj(t, defs2));
  },

  rollup_basic_metrics(){
    const summable_fields = [
      'gm_dau',
      'apv_bet',
      'house_net_win',
      'binded_bet',
      'binded_house_net_win',
      'dpst_amt',
      'dpst_count',
      'wdrl_amt',
      'wdrl_count',
      'join_amt',
      'bonus_amt',
      'bonus_out_amt',
      'bonus_19_amt',
      'bonus_20_amt',
      'rpoint_add_amt',

      'game_item_count',
      'game_item_cost',
      'game_item_bet',
      'game_item_win',

      'reg_dau',
      'gm_cvt_users',
      'dpst_01_cvt_users',
    ];
    return this.rollup(this.build_operation(g_aq.op.sum, summable_fields));
  },
});
